import {
  EmployeeCalendarEvent,
  EmployeeCalendarPersonWithLegalEntityId,
} from '~/components/EmployeeCalendar';
import { AbsenceEntry } from '~/data/absences/types';

export const convertAbsenceEntriesToEmployeeCalendarEvents = (
  absenceEntries: AbsenceEntry[],
  calendarPerson: EmployeeCalendarPersonWithLegalEntityId,
): EmployeeCalendarEvent[] => {
  const { firstName, lastName, employeeId, profilePic } = calendarPerson;

  return absenceEntries
    .filter(({ empId }) => employeeId === empId)
    .map((entry: AbsenceEntry): EmployeeCalendarEvent => {
      const { uid, empId, startDate, endDate, type, status, reason } = entry;

      return {
        uId: uid!,
        startDate: startDate!,
        endDate,
        eventCategory: type,
        eventCode: reason?.code ?? '',
        status,
        employeeId: empId!,
        firstName,
        lastName,
        profilePic,
      };
    });
};
